import React, {useState, useEffect} from 'react'
import restApi from '../../../api/Source';
import Footer from "../../../components/user/Footer/Footer";
import Header from "../../../components/user/Header/Header";
import { withRouter } from 'react-router-dom';
import LoadingSpinner from '../../../components/user/LoadingSpinner/LoadingSpinner';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import './MyAccount.css';

const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: '33.33%',
      flexShrink: 0,
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary,
    },
}));

function MyAccount(props) {

    const [isLoading, setLoading] = useState(true);
    // ACORDION
    const classes = useStyles();
    const [expanded, setExpanded] = React.useState(false);
    
    const [commercialAdaos, setCommercialAdaos] = React.useState({'value': 0});

    const [manageOption, setManageOption] = useState({
        displayMyOrders: false,
        displayMySettings: false
    });

    let statusMapping = {PENDING: "Comenzi plasate", 
        SENT: "Comenzi acceptate", 
        PROCESSED: "Comenzi facturate",
        DELIVERED: "Comenzi livrate",
        RETURNED: "Comenzi returnate",
        CANCELLED: "Comenzi anulate"};

    
    useEffect(() => {
        window.scroll(0, 0);
        setLoading(true);
        restApi.get("/services/user/" + localStorage.getItem("user") + "/commercial-adaos").then(commercialAdaos => {
            setCommercialAdaos(commercialAdaos.data);
            setLoading(false);
        }).catch(error => {
            setLoading(false);
            if (error.response.status === 401) {
                navigateTo('/');
            }
        });
    }, []);


    const navigateTo = (page) => {
        props.history.push(page);
    }

    if (localStorage.getItem("isAuthenticated") === false || localStorage.getItem("userRole") !== "USER") {
        navigateTo('/');
    }

    const viewMyOrders = () => {
        setLoading(true);
        props.getUserOrders();
        setManageOption({...manageOption, 'displayMyOrders': true, 'displayMySettings': false});
        setLoading(false);
    }

    const viewMySettings = () => {
        setManageOption({...manageOption, 'displayMyOrders': false, 'displayMySettings': true});
    }

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const handleEditCommercialAdaos = (e) => {
        console.log(e.target.value);
        if (e.target.value !== null && e.target.value !== undefined && e.target.value !== '') {
            setCommercialAdaos({...commercialAdaos, 'value': e.target.value})
        } else {
            setCommercialAdaos({...commercialAdaos, 'value': 0})
        }
    }

    const editCommercialAdaos = () => {
        restApi.put("/services/user/" + localStorage.getItem("user") + "/commercial-adaos", commercialAdaos).then(res => {
            console.log(res);
            localStorage.setItem("commercialAdaos", commercialAdaos.value);
        }).catch(error => {
            console.log("Something has failed");
        });
      }

    return (
        <div className="page-container my-account">
            <div id="content-wrap">
                <Header {...props} />

                <div className="container-fluid mt-4">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-8 col-lg-6">
                            <nav className="navbar navbar-expand-lg navbar-light my-account-menu">
                                <div className="w-100" id="navbarSupportedContent">
                                    <ul className="navbar-nav d-flex flex-row justify-content-center w-100">
                                        <li className="nav-item orders flex-fill">
                                            <button 
                                                className={`nav-link btn w-100 ${manageOption.displayMyOrders ? 'active' : ''}`} 
                                                onClick={() => viewMyOrders()}
                                            >
                                                Comenzile mele
                                            </button>
                                        </li>
                                        <li className="nav-item settings flex-fill">
                                            <button 
                                                className={`nav-link btn settings w-100 ${manageOption.displayMySettings ? 'active' : ''}`} 
                                                onClick={() => viewMySettings()}
                                            >
                                                Setari
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
                {isLoading === true && 
                    <LoadingSpinner />
                }
                {isLoading === false && manageOption.displayMyOrders === true && 
                    <div className="container-fluid mt-4">
                        {props.userOrders && props.userOrders.length > 0 && props.userOrders.some(order => order.orders && order.orders.length > 0) ? (
                            props.userOrders.map((userOrder) => (
                                userOrder.orders !== null && userOrder.orders.length > 0 ? (
                                    <Accordion key={userOrder.status} expanded={expanded === (userOrder.status)} onChange={handleChange(userOrder.status)} className="mb-3">
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                        >
                                            <Typography className={classes.heading}>{statusMapping[`${userOrder.status}`]}</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Typography component="div" style={{ width: '100%' }}>
                                                {userOrder.orders.map((order, orderIdx) => (
                                                    <div key={orderIdx} className="mb-4">
                                                        {order.description && (
                                                            <div className="mb-3 p-3 bg-light rounded">
                                                                <h6 className="mb-0"><strong>Mentiuni:</strong> <span>{order.description}</span></h6>
                                                            </div>
                                                        )}
                                                        <div className="table-responsive">
                                                            <table className="table table-striped table-hover">
                                                                <thead className="thead-light">
                                                                    <tr>
                                                                        <th scope="col">ArticleNr</th>
                                                                        <th scope="col">ProductName</th>
                                                                        <th scope="col">SupplierBrand</th>
                                                                        <th scope="col">Cantitate</th>
                                                                        <th scope="col">Data trimitere comanda</th>
                                                                        <th scope="col">Pret</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {order.products.map((product, productIdx) => (
                                                                        <tr key={productIdx}>
                                                                            <td>{product.articleNumber}</td>
                                                                            <td>{product.productName}</td>
                                                                            <td>{product.supplierBrand}</td>
                                                                            <td>{product.quantity}</td>
                                                                            <td>{product.submittedDate}</td>
                                                                            <td>{product.price} RON</td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                ))}
                                            </Typography>
                                        </AccordionDetails>
                                    </Accordion>
                                ) : null
                            ))
                        ) : (
                            <div className="text-center py-5">
                                <h5 className="mb-3">Nu aveți comenzi</h5>
                                <p className="text-muted">Momentan nu aveți comenzi plasate.</p>
                            </div>
                        )}
                    </div>
                }
                {isLoading === false && manageOption.displayMySettings === true && 
                    <div className="container-fluid mt-4">
                        <div className="row justify-content-center">
                            <div className="col-12 col-md-6">
                                <div className="card shadow-sm">
                                    <div className="card-body">
                                        <h5 className="card-title mb-4">Setări</h5>
                                        <div className="form-group">
                                            <label htmlFor="commercialAdaos" className="font-weight-bold mb-2">Adaos comercial (%)</label>
                                            <input 
                                                id="commercialAdaos"
                                                type="number" 
                                                step="any" 
                                                className="form-control mb-3"
                                                placeholder={commercialAdaos.value || "0"} 
                                                onChange={(e) => handleEditCommercialAdaos(e)} 
                                            />
                                            <small className="form-text text-muted">
                                                Introdu procentul de adaos comercial dorit.
                                            </small>
                                        </div>
                                        <button 
                                            type="button" 
                                            className="btn btn-success btn-block" 
                                            onClick={() => editCommercialAdaos()}
                                        >
                                            Salveaza
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
            <Footer />
        </div>
    )
}

export default withRouter(MyAccount);